import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Pocket } from '@pelotoncycle/waffles';
import { useRouter } from 'next/router';
import { concat } from 'ramda';
import * as React from 'react';
import useSWR from 'swr';
import { toCountryFromLocale } from '@peloton/internationalize';
import { isBirthdayOldEnough, putUser } from '@engage/api-v2';
import { getOkValue } from '@engage/result';
import { useTrackSubmittedAgeConfirmation, useTrackUpdatedUserAge, useTrackViewedAgeConfirmationError } from '@webtv/analytics';
import { useIsLoggedIn } from '@webtv/auth';
import { useCopy } from '@webtv/copy-provider';
import { UsersFetchers } from '@webtv/data-fetch';
import { engageApi } from '@webtv/data-fetch/singletons';
import { PELOTON_PLATFORM } from '@webtv/env';
import { getLocale, InternationalizeProvider } from '@webtv/internationalize';
import { FullScreenSpinner } from '@webtv/shared-ui';
import { AgeGateModalView } from './AgeGateModalView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AgeGateWhitelist = ['/welcome', '/error', '/reset-password', '/terms', '/choose-username', '/create-account', '/free-trial', '/login', '/subscription'];
export var AgeGateModal = function AgeGateModal(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(InternationalizeProvider, {
    page: "ageGate",
    pelotonPlatform: PELOTON_PLATFORM,
    children: /*#__PURE__*/_jsx(AgeGateModalWithCopy, {
      children: children
    })
  });
};

var AgeGateModalWithCopy = function AgeGateModalWithCopy(_ref2) {
  var children = _ref2.children;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      errorsEncountered = _React$useState2[0],
      setErrorsEncountered = _React$useState2[1];

  var _React$useState3 = React.useState(undefined),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      toast = _React$useState4[0],
      setToast = _React$useState4[1];

  var _useSWR = useSWR.apply(void 0, _toConsumableArray(UsersFetchers.GetIsUserOldEnough({}))),
      data = _useSWR.data,
      mutate = _useSWR.mutate;

  var _useSWR2 = useSWR.apply(void 0, _toConsumableArray(UsersFetchers.GetMe({
    pelotonPlatform: PELOTON_PLATFORM
  }))),
      user = _useSWR2.data;

  var router = useRouter();
  var errorCopy = useCopy('ageGate.somethingWentWrong');

  var _useIsLoggedIn = useIsLoggedIn(),
      isLoggedIn = _useIsLoggedIn.isLoggedIn;

  var trackSubmittedAgeConfirmation = useTrackSubmittedAgeConfirmation();
  var trackViewedAgeConfirmationError = useTrackViewedAgeConfirmationError();
  var trackUpdatedUserAge = useTrackUpdatedUserAge();
  var validateBirthdate = React.useCallback(function (birthdate) {
    isBirthdayOldEnough(engageApi, birthdate.unix(), toCountryFromLocale(getLocale(PELOTON_PLATFORM))).then( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
        var _user$id, _value$data$errorMess, _value$data$errorMess2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!value.data.oldEnough) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return putUser(engageApi, (_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : '', PELOTON_PLATFORM, {
                  birthday: birthdate.unix()
                });

              case 3:
                mutate(value.data);
                trackUpdatedUserAge(errorsEncountered.length);
                _context.next = 10;
                break;

              case 7:
                setErrorsEncountered(concat(errorsEncountered, [(_value$data$errorMess = value.data.errorMessage) !== null && _value$data$errorMess !== void 0 ? _value$data$errorMess : '']));
                setToast(value.data.errorMessage);
                trackViewedAgeConfirmationError((_value$data$errorMess2 = value.data.errorMessage) !== null && _value$data$errorMess2 !== void 0 ? _value$data$errorMess2 : '');

              case 10:
                trackSubmittedAgeConfirmation(errorsEncountered.length + (value.data.errorMessage ? 1 : 0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()).catch(function () {
      setToast(errorCopy);
    });
  }, [mutate, user === null || user === void 0 ? void 0 : user.id, errorCopy, trackSubmittedAgeConfirmation, trackViewedAgeConfirmationError, trackUpdatedUserAge, errorsEncountered, setErrorsEncountered]);
  var handleSubmit = React.useCallback(function (birthdate) {
    validateBirthdate(birthdate);
  }, [validateBirthdate]);

  if (!getOkValue(isLoggedIn) || data !== null && data !== void 0 && data.oldEnough || AgeGateWhitelist.find(function (path) {
    return router.pathname.startsWith(path);
  }) !== undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  if (data === undefined) {
    return /*#__PURE__*/_jsx(FullScreenSpinner, {});
  }

  return /*#__PURE__*/_jsx(Pocket, {
    id: "modal",
    children: /*#__PURE__*/_jsx(AgeGateModalView, {
      handleSubmit: handleSubmit,
      toast: toast,
      errorsEncountered: errorsEncountered
    })
  });
};